// extracted by mini-css-extract-plugin
module.exports = {"menuPage":"MenuPage_menuPage__pNj93","header":"MenuPage_header__HF_R4","backContainer":"MenuPage_backContainer__p81Vu"};